var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhonegold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2590_44735)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6168 12.9468H20.9384C20.9384 9.55674 18.379 7 14.9844 7V8.32166C17.6687 8.32166 19.6168 10.2665 19.6168 12.9468Z",
    fill: "#2B2B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4797 11.3552C16.0399 11.3552 16.7053 12.0207 16.7053 13.5809H18.1891C18.1891 11.1883 16.8723 9.8714 14.4797 9.8714V11.3552ZM17.0184 15.3933C16.8759 15.2637 16.6885 15.1946 16.496 15.2006C16.3034 15.2065 16.1207 15.2871 15.9864 15.4252L14.2111 17.251C13.7838 17.1694 12.9247 16.9016 12.0403 16.0194C11.156 15.1344 10.8882 14.273 10.8088 13.8487L12.6331 12.0726C12.7714 11.9384 12.8521 11.7557 12.858 11.5631C12.864 11.3705 12.7947 11.1831 12.665 11.0406L9.92371 8.02631C9.79391 7.88339 9.61351 7.7967 9.42082 7.78465C9.22814 7.7726 9.03834 7.83614 8.89174 7.96177L7.28184 9.34243C7.15357 9.47116 7.07702 9.64249 7.06669 9.82392C7.05556 10.0094 6.84338 14.4029 10.2501 17.8111C13.2222 20.7824 16.945 20.9998 17.9703 20.9998C18.1201 20.9998 18.2121 20.9953 18.2366 20.9938C18.418 20.9837 18.5892 20.9068 18.7173 20.7779L20.0973 19.1673C20.223 19.0208 20.2867 18.831 20.2747 18.6384C20.2628 18.4457 20.1763 18.2652 20.0335 18.1353L17.0184 15.3933Z",
    fill: "#2B2B2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_44735",
    x1: 14,
    y1: -5.04,
    x2: 14,
    y2: 32.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonegold);
export default __webpack_public_path__ + "static/media/phonegold.3ed5571d3da1f2668f79c66f9bc490bb.svg";
export { ForwardRef as ReactComponent };